import React, { useState } from "react";
import { submitAIConsignment } from "../../Model/aiConsignmentData";
import "./ConsignmentForm.css";

const ConsignmentForm = () => {
  const [form, setForm] = useState({
    fullname: "",
    email: "",
    phoneNumber: "",
    title: "",
    artist: "",
    year: "",
    medium: "",
    details: "",
  });

  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!frontImage) {
      setError("Please upload the front image of your artwork.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      Object.entries(form).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append("frontImage", frontImage);

      if (backImage) {
        formData.append("backImage", backImage);
      }

      const result = await submitAIConsignment(formData);

      if (!result?.success) {
        setError(
          result?.message ||
            "Unable to submit your artwork."
        );
        return;
      }

      setSubmitted(true);
    } catch (err) {
      console.error(err);

      setError(
        "Unable to submit your artwork. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="consignment-success">
        <div className="consignment-success-icon">
          ✓
        </div>

        <h3>Submission Received</h3>

        <p>
          Thank you. Your artwork has been submitted
          successfully for review by Leon Gallery.
        </p>

        <p>
          Our team will review the information
          and artwork submitted.
        </p>
      </div>
    );
  }

  return (
    <form
      className="consignment-form"
      onSubmit={handleSubmit}
    >
      <div className="consignment-form-title">
        Submit Your Artwork
      </div>

      <div className="consignment-form-subtitle">
        Please provide the details of the artwork
        you would like Leon Gallery to review.
      </div>

      <label>Front Artwork Image *</label>

      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={(e) =>
          setFrontImage(e.target.files?.[0] || null)
        }
      />

      <label>Back Artwork Image</label>

      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={(e) =>
          setBackImage(e.target.files?.[0] || null)
        }
      />

      <label>Artwork Title *</label>

      <input
        name="title"
        value={form.title}
        onChange={handleChange}
        placeholder="Artwork title"
        required
      />

      <label>Artist</label>

      <input
        name="artist"
        value={form.artist}
        onChange={handleChange}
        placeholder="Artist name"
      />

      <label>Year</label>

      <input
        name="year"
        value={form.year}
        onChange={handleChange}
        placeholder="Year"
      />

      <label>Medium</label>

      <input
        name="medium"
        value={form.medium}
        onChange={handleChange}
        placeholder="Oil on canvas, watercolor, etc."
      />

      <label>Details</label>

      <textarea
        name="details"
        value={form.details}
        onChange={handleChange}
        placeholder="Tell us more about the artwork..."
        rows={4}
      />

      <div className="consignment-section-title">
        Your Information
      </div>

      <label>Your Name *</label>

      <input
        name="fullname"
        value={form.fullname}
        onChange={handleChange}
        placeholder="Full name"
        required
      />

      <label>Email *</label>

      <input
        type="email"
        name="email"
        value={form.email}
        onChange={handleChange}
        placeholder="Email address"
        required
      />

      <label>Phone</label>

      <input
        name="phoneNumber"
        value={form.phoneNumber}
        onChange={handleChange}
        placeholder="Phone number"
      />

      {error && (
        <div className="consignment-form-error">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="consignment-submit-button"
      >
        {loading
          ? "Submitting..."
          : "Submit for Review"}
      </button>
    </form>
  );
};

export default ConsignmentForm;